<template>
    <div name="result" class="list" >
        <span v-if="searchItems.length > 0" style="margin-bottom: 20px;" class="count-text">총 <span class="count-text-bold">{{ searchItems.length }}개</span></span>
        <div class="item" v-for="(item, index) in searchItems" v-if="searchItems.length > 0">
            <!-- <img class="item-image" /> -->
            <div class="item-image">
                <img style="width: 100%;height: 100%;" :src="item.imageUrl" />
            </div>
            <div class="item-contents">
                <span class="item-name-text">{{ item.name }}</span>
                <span class="item-info-text" style="margin-top: 8px; margin-bottom: 8px;">{{ convertCategoryToString(item.category) }}<span class="item-info-bar">|</span><span :style="'font-weight: 600'">{{ setComma(item.price) }}원</span></span>
                <div class="row" style="width: auto; justify-content:  flex-start; padding: 4px 8px;box-sizing: border-box; justify-content: flex-start;background: var(--Gray-20, #F3F5F8);border-radius: 6px; " v-if="item.category !== 7 && !allPayment">
                    <span class="tag">{{ adultSaleCheck(item) }}</span><span class="red">{{ ratioCheck(item) }}</span><span class="price">{{ setComma(salePriceCheck(item)) }}원</span>
                </div>

                <div class="row" style="margin-top: 16px;">
                    <div style="display: flex;justify-content: center;align-items: center;">
                        <div class="box-button" @click="minus(item, index)">
                            -
                        </div>
                        <input
                            class="input-small"
                            inputmode="numeric" 
                            maxlength="4"
                            v-model="innrSelectedCount[index]" 
                            @input="changeCount(item, index)"
                            />     
                        <div class="box-button2" @click="plus(item, index)">
                            +
                        </div>
                    </div>
                    <div v-if="!isSelectedItem(item.id)" class="item-select-button" @click="selectItem(item, innrSelectedCount[index])">
                        추가
                    </div>
                    <div v-else class="item-select-button" style="color: var(--Semantic-01_Red, #FF000F);" @click="deleteItem(item)">
                        삭제
                    </div>
                </div>

            </div>
        </div>
        <div v-if="searchItems.length === 0" class="item-empty">
            <img style="width: 90px;" src="../../../../assets/icn_search_big.png" />
            <span class="empty-title">검색 결과가 없습니다.</span>
            <span class="empty-description">이렇게도 검색 가능해요!<br>
                제품명 (예시: 주사기, 팁, 수액세트 등)<br>
                상품유형 카테고리 검색</span>
        </div>
        <div class="bottom-toast-alarm" v-if="isVisible" @click="onClose">
            <span v-if="isSelect">추가되었습니다.</span>
            <span v-if="!isSelect">삭제되었습니다.</span>
            <span>보러가기 ></span>
        </div>
        <div class="bottom-toast-alarm" v-if="isCountToastVisible" >
            <span>해당 제품은 최대 {{maxCount}}개까지만 구매 가능합니다</span>
            <span @click="onCountToastClose">X</span>
        </div>
    </div>

</template>

<script>
import Convert from '@/utilities/convert';

export default {
    name: 'result',
    props: ['searchItems', 'selectedIdList', 'ratio', 'isAdult', 'autoInjector', 'selectedCount', 'allPayment'],
    mounted: function()
    {

        if(this.searchItems.length === 0)
        {
            this.isEmpty = true;
        }
        else
        {
            this.isEmpty = false;
        }

        this.innrSelectedCount = [];
        for(var i = 0; i < this.searchItems.length; i++)
        {
           
            const index = this.selectedIdList.indexOf(this.searchItems[i].id)
 
            if(index > -1)
            {
                if(this.selectedCount[index] === undefined || this.selectedCount[index] === null)
                {
                    this.innrSelectedCount.push(1);
                }
                else
                {
                    this.innrSelectedCount.push(this.selectedCount[index])
                }
            }
            else
            {
                this.innrSelectedCount.push(1)
            }
        }
    },
    data: function()
    {
        return {
            isVisible: false,
            isSelect: true,
            timerId: null,
            isEmpty: false,
            innrSelectedCount: [],
            countTimerId: null,
            isCountToastVisible: false,
            maxCount: 0
        }
    },
    methods: {
        changeCount: function(item, index)
        {
            if(item.maxCount !== null)
            {
                if(item.maxCount < this.innrSelectedCount[index])
                {
                    this.$set(this.innrSelectedCount, index, Number(item.maxCount));
                    this.showCountToastElement(item.maxCount);
                }
            }

            if(this.isSelectedItem(item.id))
            {
                this.$emit('selectItem', item, this.innrSelectedCount[index])
            }
        },
        adultSaleCheck: function(item)
        {
            
            if(item.category !== 7)
            {
                if(this.isAdult === true)
                {
                    return '19세 이상'
                }
                else
                {
                    return '19세 미만'
                }
            }
            
            return;

        },
        ratioCheck: function(item)
        {
            if(item.category === 3)
            {
                if(this.isAdult === true)
                {
                    return '-70%'
                }
                else
                {
                    return '-90%'
                }
            }
            else if(item.category === 8)
            {
                return '-70%'
            }
            else if(item.category !== 7)
            {
                if(!this.isAdult && this.autoInjector)
                {
                    return '-70%'
                }
                return '-90%';
            }
            
            return;
        },
        salePriceCheck: function(item)
        {
            if(item.category === 3)
            {
                if(this.isAdult === true )
                {
                    return item.price * 0.3;
                }
                else
                {
                    return item.price * 0.1;
                }
            }
            else if(item.category === 8)
            {
                return item.price * 0.3;
            }
            else if(item.category !== 7)
            {
                if(!this.isAdult && this.autoInjector)
                {
                    return item.price * 0.3;
                }
                return item.price * 0.1;
            }
            
            return;
        },
        plus: function(item, index)
        {
            if (this.innrSelectedCount[index] === null) {
                this.$set(this.innrSelectedCount, index, 1); // Vue 2: 반응형 업데이트
            } else {
                if(this.isNumberStrict(Number(this.innrSelectedCount[index])))
                {
                    this.$set(this.innrSelectedCount, index, Number(this.innrSelectedCount[index]) + 1);
                }
                else
                {
                    this.$set(this.innrSelectedCount, index, 1);
                }
            }

            if(item.maxCount !== null)
            {
                if(item.maxCount < this.innrSelectedCount[index])
                {
                    this.$set(this.innrSelectedCount, index, Number(item.maxCount));
                    this.showCountToastElement(item.maxCount);
                }
            }


            if(this.isSelectedItem(item.id))
            {
                this.$emit('selectItem', item, this.innrSelectedCount[index])
            }

        },
        minus: function(item, index) {
            if (this.innrSelectedCount[index] > 0) {
                this.$set(this.innrSelectedCount, index, Number(this.innrSelectedCount[index]) - 1); // Vue 2: 반응형 업데이트
            } else {
                this.$set(this.innrSelectedCount, index, 0); // 값이 0보다 작아지지 않도록 방지
            }

            if(this.isSelectedItem(item.id))
            {
                this.$emit('selectItem', item, this.innrSelectedCount[index])
            }

        },
        isNumberStrict: function (value) {
            return typeof value === 'number' && !Number.isNaN(value);
        },
        onCountToastClose: function()
        {
            this.countTimerId = null;
            this.isCountToastVisible = false;
            this.maxCount = 0;
        },
        onClose: function()
        {
            this.$emit('onClose')
        },
        showToastElement() {
            if (this.timerId) {
                clearTimeout(this.timerId);
            }
            this.isVisible = true;
            this.timerId = setTimeout(() => {
                this.timerId = null;
                this.isVisible = false;
            }, 20000); // 2초 후에 숨김
        },
        showCountToastElement(maxCount) {
            this.maxCount = maxCount
            if (this.countTimerId) {
                clearTimeout(this.countTimerId);
            }
            this.isCountToastVisible = true;
            this.countTimerId = setTimeout(() => {
                this.countTimerId = null;
                this.isCountToastVisible = false;
                this.maxCount = 0;
            }, 4000); // 2초 후에 숨김
        },
        selectItem: function(item, count)
        {
            this.isSelect = true;
            this.$emit('selectItem', item, count)
            this.showToastElement()
        },
        deleteItem: function(item)
        {
            this.isSelect = false;
            this.$emit('deleteItem', item)
            this.showToastElement()
        },
        isSelectedItem: function(id)
        {
            if(this.selectedIdList)
            {
                return this.selectedIdList.includes(id);
            }
            else
            {
                return false;
            }

        },
        convertCategoryToString: function(category)
        {
            if(category === 0)
            {
                return '펜니들'
            }
            else if(category === 1)
            {
                return '혈당검사지'
            }
            else if(category === 2)
            {
                return '채혈침'
            }
            else if(category === 3)
            {
                return '연속혈당측정기'    
            }
            else if(category === 4)
            {
                return '펌프용 주사기'
            }
            else if(category === 5)
            {
               return '주사기'
            }
            else if(category === 6)
            {
                return '펌프용 주사바늘'
            }
            else if(category === 7)
            {
                return '기타'
            }
            else if(category === 8)
            {
                return '관리기기'
            }
        },
        setComma: function(data)
        {
            return Convert.setComma(data);
        },
    }

}
</script>

<style scoped>
    .list {
        width: 100%;
        height: 100vh;
        overflow-y: auto;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 0 16px;
        padding-bottom: 67px;
    }
    .item {
        border: 1px solid var(--gray-30-stroke, #E8EAEE);
        background: var(--Gray-00, #FFF);
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        width: 100%;
        padding: 8px 8px 8px 7.29px;
        margin-bottom: 8px;
        border-radius: 6px;
    }
    .item-empty {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-top: 97px;
    }
    .count-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px; /* 94.444% */
    }
    .count-text-bold {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px;
    }
    .item-image {
        width: 107px;
        height: 88px;
        margin-right: 9.5px;
        box-sizing: border-box;
        border-radius: 8px;
        overflow: hidden;
    }
    .item-contents {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        box-sizing: border-box;
        padding-left: 8.19px;
        flex-direction: column;
    }
    .item-name-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 100%;
    }
    .item-info-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        width: 100%;
    }
    .item-info-bar {
        color: #D1D6DB;
        font-size: 17px;
        margin-left: 4.4px;
        margin-right: 4.4px;
    }
    .item-select-button {
        display: flex;
        width: 64px;
        height: 32px;
        justify-content: center;
        align-items: center;    
        color: #184FA1;
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        cursor: pointer;
    }
    .bottom-toast-alarm {
        color: #FFF;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        height: 57px;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-60, #6B7684);
        backdrop-filter: blur(2px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        box-sizing: border-box;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 32px);
        animation: fadeIn 0.5s forwards;
        cursor: pointer;
    }

    .empty-title {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px; /* 94.444% */
        margin-top: 30px;
    }
    .empty-description {
        color: var(--Gray-50, #A3AAB6);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
        margin-top: 16px;
    }
    .input-small {
        width: 50px;
        height: 40px;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        box-sizing: border-box;
        text-align: center;
        border: 0;
        background: #FFF;
    }
        .box-button {
        width: 35px;
        height: 28px;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-family: Pretendard;
        font-size: 25px;
        padding-bottom: 4px;
    }
    .box-button2 {
        width: 35px;
        height: 28px;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-20, #F3F5F8);
        box-sizing: border-box;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-family: Pretendard;
        font-size: 25px;
        padding-bottom: 4px;
    }
    .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        padding-right: 8px;
    }
    .tag {
        border-radius: 6px;
        background: #184FA1;
        width: 63px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 4px 0;
        box-sizing: border-box;
        color: var(--Gray-00, #FFF);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .red {
        color: var(--Semantic-01_Orange, #FC7E2F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-left: 4px;
    }
    .price {
        color: var(--Gray-100, #1E1E1E);
        text-align: right;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin-left: 8px;
    }

    /* v-if를 사용할 때 사라질 때 애니메이션 효과 */
    .bottom-toast-alarm.v-leave-active {
        animation: fadeOut 0.5s forwards;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            /* transform: translateY(-10px); */
        }
        to {
            opacity: 1;
            /* transform: translateY(0); */
        }
    }

    /* 사라질 때 애니메이션 */
    @keyframes fadeOut {
        from {
            opacity: 1;
            /* transform: translateY(0); */
        }
        to {
            opacity: 0;
            /* transform: translateY(-10px); */
        }
    }

    @media (min-width: 600px) {
        .bottom-toast-alarm {
            width: 564px;            
        }        
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/calculator/rare/Result.vue